class JsErrorReporter {
	constructor() {
		this.ajaxUrl = window.drAjax?.ajaxurl;
		this.nonce = window.drAjax?.nonce;
		this.sentKeys = new Set();
		this.sessionKey = "dr_error_reporter_sent";
		this.sessionLimitKey = "dr_error_reporter_limit";
		this.maxPerSession = 10; // 0 = unlimited; set >0 to enable limit
	}

	init() {
		if (!this.ajaxUrl || !this.nonce) {
			return;
		}
		this.restoreSessionCache();
		this.bindEvents();
	}

	bindEvents() {
		window.addEventListener("error", this.handleError.bind(this), true);
		window.addEventListener("unhandledrejection", this.handleRejection.bind(this), true);
	}

	handleError(event) {
		const message = event?.message || "";
		if (!this.isSecurityMessage(message)) return;
		this.sendError(message, event.filename, event.lineno, event.colno);
	}

	handleRejection(event) {
		try {
			const reason = event?.reason;
			const message = typeof reason === "string" ? reason : reason?.message || "";
			if (!this.isSecurityMessage(message)) return;
			this.sendError("Promise rejection: " + message, location.href, 0, 0);
		} catch (e) {
			// no-op
		}
	}

	handleCspViolation(event) {
		const msg = `CSP violation: ${event.violatedDirective} - ${event.blockedURI || ""}`;
		this.sendError(msg, event.documentURI || location.href, 0, 0);
	}

	isSecurityMessage(message = "") {
		const m = String(message);
		return m.includes("CORS") || m.includes("blocked by CORS policy") || m.includes("Content Security Policy") || m.includes("CSP violation");
	}

	buildKey(message, file, line, col) {
		const base = [String(message).slice(0, 300), file || "", line || 0, col || 0].join("|");
		let hash = 0;
		for (let i = 0; i < base.length; i++) {
			hash = (hash << 5) - hash + base.charCodeAt(i);
			hash |= 0;
		}
		return String(hash);
	}

	restoreSessionCache() {
		try {
			const raw = sessionStorage.getItem(this.sessionKey);
			if (raw) {
				const arr = JSON.parse(raw);
				if (Array.isArray(arr)) arr.forEach((k) => this.sentKeys.add(k));
			}
			const limitRaw = sessionStorage.getItem(this.sessionLimitKey);
			if (limitRaw && !isNaN(parseInt(limitRaw))) {
				this.currentSentCount = parseInt(limitRaw) || 0;
			} else {
				this.currentSentCount = 0;
			}
		} catch (e) {
			// no-op
		}
	}

	persistSessionCache() {
		try {
			sessionStorage.setItem(this.sessionKey, JSON.stringify(Array.from(this.sentKeys)));
			sessionStorage.setItem(this.sessionLimitKey, String(this.currentSentCount || 0));
		} catch (e) {
			// no-op
		}
	}

	sendError(message, file, line, col) {
		const debug = /(?:^|[?&])errdebug=1(?:&|$)/.test(location.search);
		if (!debug && this.maxPerSession > 0 && (this.currentSentCount || 0) >= this.maxPerSession) {
			return;
		}
		const key = this.buildKey(message, file, line, col);
		if (!debug) {
			if (this.sentKeys.has(key)) return;
			this.sentKeys.add(key);
			this.currentSentCount = (this.currentSentCount || 0) + 1;
			this.persistSessionCache();
		}

		const params = new URLSearchParams();
		params.set("action", "report_frontend_error");
		params.set("_ajax_nonce", this.nonce);
		params.set("message", String(message || ""));
		params.set("file", String(file || ""));
		params.set("page_url", String(location.href));
		if (debug) params.set("debug", "1");
		params.set("line", String(line || 0));
		params.set("col", String(col || 0));

		try {
			fetch(this.ajaxUrl, {
				method: "POST",
				headers: { "Content-Type": "application/x-www-form-urlencoded" },
				body: params.toString(),
				keepalive: true,
				credentials: "same-origin",
			}).catch(() => {});
		} catch (e) {
			// no-op
		}
	}
}

const errorReporter = new JsErrorReporter();
document.addEventListener("DOMContentLoaded", () => errorReporter.init());
window.DR_ErrorReporter = errorReporter;
export default errorReporter;
